// Mock data for Rozsviť Přerov website

// Helper function to get current Czech time
const getCzechTime = () => {
  return new Date().toLocaleString("en-US", { timeZone: "Europe/Prague" });
};

// Helper function to check if a day should be revealed (12:00 Czech time)
const shouldDayBeRevealed = (day) => {
  const czechTimeString = getCzechTime();
  const czechTime = new Date(czechTimeString);
  
  const currentYear = czechTime.getFullYear();
  const revealDate = new Date();
  revealDate.setFullYear(currentYear, 11, day); // December (month 11), day
  revealDate.setHours(12, 0, 0, 0); // 12:00:00.000
  
  // Convert reveal date to Czech time for comparison
  const revealDateCzech = new Date(revealDate.toLocaleString("en-US", { timeZone: "Europe/Prague" }));
  
  return czechTime >= revealDateCzech;
};

// Helper function to check if a day is currently active (today in Czech time)
const isDayActive = (day) => {
  const czechTimeString = getCzechTime();
  const czechTime = new Date(czechTimeString);
  
  const currentYear = czechTime.getFullYear();
  const currentMonth = czechTime.getMonth();
  const currentDate = czechTime.getDate();
  
  // Check if today is the specific December day
  return currentMonth === 11 && currentDate === day && currentYear === 2025;
};

// Helper function to check if clue should be shown (from 16:01 Czech time of previous day)
const shouldShowClue = (day) => {
  const czechTimeString = getCzechTime();
  const czechTime = new Date(czechTimeString);
  
  const currentYear = czechTime.getFullYear();
  const clueDate = new Date();
  clueDate.setFullYear(currentYear, 11, day - 1); // Previous day (day - 1)
  clueDate.setHours(16, 1, 0, 0); // 16:01:00.000
  
  // Convert clue date to Czech time for comparison
  const clueDateCzech = new Date(clueDate.toLocaleString("en-US", { timeZone: "Europe/Prague" }));
  
  return czechTime >= clueDateCzech;
};

export const mockData = {
  // Daily calendar data with real locations from JSON
  calendarDays: [
    {
      day: 1,
      location: "Hvězdárna Přerov",
      coordinates: [49.447198119418246, 17.479752501369745],
      radiusCenter: [49.447, 17.479], // Approximate area center for unrevealed locations
      radiusKm: 0.1,
      clue: "Kde se dívají tam, kam oči běžně nedosáhnou – a kde tma ukazuje víc než světlo?",
      description: "Slavnostní zahájení s primátorem a maskot Hvězdička Třpytka",
      revealTime: "16:00"
    },
    {
      day: 2,
      location: "Středisko volného času ATLAS - Žižkova",
      coordinates: [49.45153904151731, 17.46695304677459],
      radiusCenter: [49.451, 17.467],
      radiusKm: 0.1,
      clue: "Kde děti zkouší všechno od vědy po tanec – a každý den objevují novou verzi sebe?",
      description: "Vánoční program pro děti",
      revealTime: "16:00"
    },
    {
      day: 3,
      location: "Tělocvičná jednota Sokol Přerov",
      coordinates: [49.45751110408758, 17.44803986334304],
      radiusCenter: [49.457, 17.448],
      radiusKm: 0.1,
      clue: "Když křídla nejsou z peří, a přesto tě učí létat. Kde se síla a pohyb mění v radost?",
      description: "Sportovní vánoční akce",
      revealTime: "16:00"
    },
    {
      day: 4,
      location: "HOSTINEC MICHALOV",
      coordinates: [49.460490857329944, 17.456729095215966],
      radiusCenter: [49.460, 17.457],
      radiusKm: 0.1,
      clue: "Kde teplo domova najdeš uprostřed parku a vůně jídla vede cestu?",
      description: "Vánoční pohoštění",
      revealTime: "16:00"
    },
    {
      day: 5,
      location: "Nám. T.G.M. - Duckbeat",
      coordinates: [49.454904335320414, 17.448947177874388],
      radiusCenter: [49.455, 17.449],
      radiusKm: 0.1,
      clue: "Kde kroky mluví hlasitěji než slova – a rytmus rozhoduje o všem?",
      description: "Taneční vánoční show",
      revealTime: "16:00"
    },
    {
      day: 6,
      location: "Muzeum Komenského v Přerově",
      coordinates: [49.45535549719098, 17.4511386707557],
      radiusCenter: [49.455, 17.451],
      radiusKm: 0.1,
      clue: "Kde minulost šeptá a čeká, až ji někdo znovu objeví?",
      description: "Historické vánoční tradice",
      revealTime: "16:00"
    },
    {
      day: 7,
      location: "Sportovní hala SK START PŘEROV - Florbal Přerov",
      coordinates: [49.45730942427806, 17.466895103652142],
      radiusCenter: [49.457, 17.467],
      radiusKm: 0.1,
      clue: "Kde hůl, míček a rychlé nohy rozhodují o vítězství?",
      description: "Florbalový zápas",
      revealTime: "16:00"
    },
    {
      day: 8,
      location: "Policie ČR - U výstaviště",
      coordinates: [49.461380191668454, 17.452032512416007],
      radiusCenter: [49.461, 17.452],
      radiusKm: 0.1,
      clue: "Kde bdí ti, kteří chrání klid v ulicích, i když jiní spí?",
      description: "Den otevřených dveří",
      revealTime: "16:00"
    },
    {
      day: 9,
      location: "Charita Přerov - Svisle",
      coordinates: [49.45083684847136, 17.458491670088133],
      radiusCenter: [49.451, 17.458],
      radiusKm: 0.1,
      clue: "Kde i malá pomoc dokáže rozehřát velké srdce – a kde světlo roste z laskavosti?",
      description: "Charitativní vánoční akce",
      revealTime: "16:00"
    },
    {
      day: 10,
      location: "Domov Alzheimer Přerov z.ú.",
      coordinates: [49.45282602422365, 17.459715695215497],
      radiusCenter: [49.453, 17.460],
      radiusKm: 0.1,
      clue: "Kde vzpomínky někdy mizí, ale lidské teplo zůstává jako nejjemnější světlo?",
      description: "Vánoční koncert pro seniory",
      revealTime: "16:00"
    },
    {
      day: 11,
      location: "Městská knihovna v Přerově",
      coordinates: [49.454684400076836, 17.45230091241561],
      radiusCenter: [49.455, 17.452],
      radiusKm: 0.1,
      clue: "Kde šustí příběhy a ticho voní dobrodružstvím?",
      description: "Vánoční čtení",
      revealTime: "16:00"
    },
    {
      day: 12,
      location: "Vánoční trhy Předmostí",
      coordinates: [49.46531552439512, 17.43917954584631],
      radiusCenter: [49.465, 17.439],
      radiusKm: 0.1,
      clue: "Kde světlo chutná jako dobrá práce, a kde radost začíná na talíři?",
      description: "Vánoční trhy",
      revealTime: "16:00"
    },
    {
      day: 13,
      location: "PIVNICE LAGUNA",
      coordinates: [49.459888509683324, 17.467269881725016],
      radiusCenter: [49.460, 17.467],
      radiusKm: 0.1,
      clue: "Kde vládne dobrá nálada a kde se každý večer mění v malé přístavní setkání?",
      description: "Vánoční večírek",
      revealTime: "16:00"
    },
    {
      day: 14,
      location: "Přerovský Kašpárek, Loutkové divadlo Sokola Přerov",
      coordinates: [49.45753885409248, 17.448323674979395],
      radiusCenter: [49.458, 17.448],
      radiusKm: 0.1,
      clue: "Kde stačí pár provázků k probuzení celého světa?",
      description: "Vánoční loutkové představení",
      revealTime: "16:00"
    },
    {
      day: 15,
      location: "Veslařský klub Přerov",
      coordinates: [49.457388575603865, 17.45398548113393],
      radiusCenter: [49.457, 17.454],
      radiusKm: 0.1,
      clue: "Kde kroky nahradí tahy a cesta je vždy po hladině?",
      description: "Vánoční veslařský program",
      revealTime: "16:00"
    },
    {
      day: 16,
      location: "Nemocnice AGEL Přerov",
      coordinates: [49.456603575749234, 17.473682476996522],
      radiusCenter: [49.457, 17.474],
      radiusKm: 0.1,
      clue: "Kde začíná uzdravení a končí strach – a kde světlo drží naději za ruku?",
      description: "Vánoční koncert pro pacienty",
      revealTime: "16:00"
    },
    {
      day: 17,
      location: "Základní umělecká škola Přerov",
      coordinates: [49.45261507316621, 17.455902208706398],
      radiusCenter: [49.453, 17.456],
      radiusKm: 0.1,
      clue: "Kde tóny kreslí do ticha a barvy tančí podle fantazie?",
      description: "Vánoční koncert žáků",
      revealTime: "16:00"
    },
    {
      day: 18,
      location: "Kostel svatého Vavřince",
      coordinates: [49.453919492437244, 17.449324357188296],
      radiusCenter: [49.454, 17.449],
      radiusKm: 0.1,
      clue: "Kde ticho umí zpívat a světlo se odráží až do duše?",
      description: "Vánoční mše",
      revealTime: "16:00"
    },
    {
      day: 19,
      location: "Dětská skupina Jasínka (Rodinka)",
      coordinates: [49.44996492178066, 17.456381639397218],
      radiusCenter: [49.450, 17.456],
      radiusKm: 0.1,
      clue: "Kde malí objevitelé zkoumají svět vlastníma rukama – a každé semínko zvědavosti roste?",
      description: "Vánoční program pro nejmenší",
      revealTime: "16:00"
    },
    {
      day: 20,
      location: "ORNIS",
      coordinates: [49.45952099217896, 17.461410795215883],
      radiusCenter: [49.460, 17.461],
      radiusKm: 0.1,
      clue: "Kde křídla nepatří andělům, ale pacientům – a kde každý příběh začíná péčí o ty, kteří létají nejvýš?",
      description: "Vánoční program veterinární kliniky",
      revealTime: "16:00"
    },
    {
      day: 21,
      location: "ORNIS – BEČVA",
      coordinates: [49.45714991637162, 17.453938160864357],
      radiusCenter: [49.457, 17.454],
      radiusKm: 0.1,
      clue: "Kde se světla mění v malá plovoucí přání a řeka je nese tiše jako šepot večera?",
      description: "Vánoční program u řeky",
      revealTime: "16:00"
    },
    {
      day: 22,
      location: "Sbor dobrovolných hasičů Přerov",
      coordinates: [49.450949615813364, 17.457676969684805],
      radiusCenter: [49.451, 17.458],
      radiusKm: 0.1,
      clue: "Kde plameny nevládnou, protože tam stojí ti, kteří s nimi umí tančit?",
      description: "Den otevřených dveří u hasičů",
      revealTime: "16:00"
    },
    {
      day: 23,
      location: "KINO HVĚZDA",
      coordinates: [49.45124210067059, 17.455113594194458],
      radiusCenter: [49.451, 17.455],
      radiusKm: 0.1,
      clue: "Kde se i tma stává kouzlem – a hvězdy svítí i uvnitř sálu?",
      description: "Vánoční filmová projekce",
      revealTime: "16:00"
    },
    {
      day: 24,
      location: "Zemědělská škola Přerov",
      coordinates: [49.46404666915041, 17.457179954743438],
      radiusCenter: [49.464, 17.457],
      radiusKm: 0.1,
      clue: "Kde půda není jen hlína, ale začátek každého růstu?",
      description: "Vánoční zakončení",
      revealTime: "16:00"
    }
  ],

  // Current day info
  currentDay: {
    day: 1,
    date: "1. prosince 2025",
    clue: "Místo, kde se díváme na hvězdy a poznáváme vesmír...",
    location: "Hvězdárna Přerov",
    timeToReveal: "16:00",
    isRevealed: false
  },

  // Visual advent calendar for bento box display
  visualCalendar: [
    // Row 1 - days 1-6
    { day: 1, size: 'large', position: 'top-left' },
    { day: 2, size: 'small' },
    { day: 3, size: 'medium' },
    { day: 4, size: 'small' },
    { day: 5, size: 'medium' },
    { day: 6, size: 'large', position: 'top-right' },
    
    // Row 2 - days 7-12
    { day: 7, size: 'medium' },
    { day: 8, size: 'small' },
    { day: 9, size: 'large', position: 'center' },
    { day: 10, size: 'small' },
    { day: 11, size: 'medium' },
    { day: 12, size: 'small' },
    
    // Row 3 - days 13-18
    { day: 13, size: 'small' },
    { day: 14, size: 'medium' },
    { day: 15, size: 'small' },
    { day: 16, size: 'large', position: 'mid-center' },
    { day: 17, size: 'medium' },
    { day: 18, size: 'small' },
    
    // Row 4 - days 19-24
    { day: 19, size: 'medium' },
    { day: 20, size: 'small' },
    { day: 21, size: 'medium' },
    { day: 22, size: 'small' },
    { day: 23, size: 'medium' },
    { day: 24, size: 'large', position: 'bottom-special' }
  ],

  // Goals/objectives
  goals: [
    {
      icon: "👨‍👩‍👧‍👦",
      title: "Spojuje generace",
      description: "Přináší společné zážitky pro celé rodiny",
      details: "Živý adventní kalendář vytváří příležitosti pro společné chvíle rodin všech věkových kategorií. Děti i dospělí mohou společně objevovat město, sbírat QR kódy a užívat si vánoční atmosféru. Každé místo nabízí program vhodný pro celou rodinu - od koled přes dílničky až po svařák pro dospělé."
    },
    {
      icon: "🏛️", 
      title: "Vyzdvihuje významné subjekty",
      description: "Představuje důležitá místa v našem městě",
      details: "Každý den se rozsvítí číslo na některém místě Přerova - od historických budov přes kulturní instituce až po místní podniky. Občané tak mají možnost poznat lépe své město a objevit místa, která možná ani nevěděli, že existují. Akce podporuje místní podniky a organizace."
    },
    {
      icon: "🚶‍♂️✨",
      title: "Motivuje k pohybu", 
      description: "Povzbuzuje k procházkám po městě",
      details: "V době, kdy většina času trávíme doma, adventní kalendář motivuje lidi vyjít ven a aktivně poznávat město. Každodenní hledání nových míst znamená pravidelný pohyb a procházky po Přerově. Hra s QR kódy motivuje k dalšímu objevování a poznávání města."
    }
  ],

  // Partners
  partners: [
    {
      name: "Olomoucký kraj",
      logo: "https://customer-assets.emergentagent.com/job_prerov-svetlo/artifacts/mst4kgmk_logook.jpg"
    },
    {
      name: "Město Přerov", 
      logo: "https://customer-assets.emergentagent.com/job_prerov-svetlo/artifacts/e7hy7w5j_49258.svg"
    }
  ],

  // Additional Partners/Sponsors
  additionalPartners: [
    {
      name: "Inky papírnictví",
      logo: "https://customer-assets.emergentagent.com/job_prerov-svetlo/artifacts/ctdcuzg7_inky.png",
      website: "https://www.papirnictviinky.cz"
    },
    {
      name: "MFP", 
      logo: "https://customer-assets.emergentagent.com/job_prerov-svetlo/artifacts/balhqbpu_mfp.png",
      website: "https://www.papirnictviinky.cz"
    },
    {
      name: "Linteo",
      logo: "https://customer-assets.emergentagent.com/job_prerov-svetlo/artifacts/3qyuj4cj_linteo.jpg",
      website: "https://www.linteo.cz"
    },
    {
      name: "Hotel Jana",
      logo: "https://customer-assets.emergentagent.com/job_prerov-svetlo/artifacts/bwgswz4f_jana.png",
      website: "https://www.hotel-jana.cz"
    },
    {
      name: "Renovality",
      logo: "https://customer-assets.emergentagent.com/job_prerov-svetlo/artifacts/dlich7ch_renovality.webp",
      website: "https://www.renovality.cz/"
    },
    {
      name: "Neon",
      logo: "https://customer-assets.emergentagent.com/job_prerov-svetlo/artifacts/p98vaksu_neon.jpg",
      website: "https://www.facebook.com/neonprerov/?locale=cs_CZ"
    },
    {
      name: "Nikol Hejlová",
      logo: "https://via.placeholder.com/120x60/D4AF37/0A1633?text=Nikol+Hejlová",
      website: "https://www.facebook.com/neonprerov/?locale=cs_CZ"
    },
    {
      name: "BV Svítidla",
      logo: "https://customer-assets.emergentagent.com/job_prerov-svetlo/artifacts/rg0i5kv8_bvsvitidla.jpg",
      website: "#" // Nenalezen odkaz
    },
    {
      name: "Racek",
      logo: "https://customer-assets.emergentagent.com/job_prerov-svetlo/artifacts/osxsucfs_racek.png",
      website: "https://www.pekarnaracek.cz/"
    },
    {
      name: "Lucie Studená fotografka",
      logo: "https://customer-assets.emergentagent.com/job_prerov-svetlo/artifacts/3wd7u09r_studena.png",
      website: "https://www.foto-studena.cz/"
    },
    {
      name: "Živina",
      logo: "https://customer-assets.emergentagent.com/job_prerov-svetlo/artifacts/g862nbe0_zivina.png",
      website: "https://www.zivina.cz/"
    },
    {
      name: "WC servis",
      logo: "https://customer-assets.emergentagent.com/job_prerov-svetlo/artifacts/54w6qsk5_wcservis.png",
      website: "tel:773237237"
    }
  ],

  // Organizers
  organizers: [
    {
      name: "Aktivitka z.s.",
      logo: "https://customer-assets.emergentagent.com/job_prerov-svetlo/artifacts/1w16zske_aktivitka_logo.png",
      description: "Hlavní organizátor akce",
      fullDescription: "Spolek Aktivitka spojuje vášeň pro kreativní a netradiční pojetí vzdělávání i volnočasových aktivit. Našim cílem je přinášet dětem i dospělým zážitky plné radosti, fantazie a objevování, které spojují celé rodiny a všechny generace s mezilidským přesahem.\n\nNaše bohaté zkušenosti s organizací akcí nám umožňují připravovat zážitkové dny, tematické stezky, příměstské i pobytové tábory a veřejné programy určené všem věkovým kategoriím.\n\nSoučástí naší činnosti jsou také kulturní a vzdělávací akce pro rodiny s dětmi i širokou veřejnost."
    }
  ],

  // Social media
  socialMedia: {
    facebook: "https://www.facebook.com/aktivitkazs",
    instagram: "https://instagram.com/rozsvitprerov", 
    facebookEvent: "https://www.facebook.com/events/1328408531964117"
  },

  // QR code game info
  qrGame: {
    description: "Na každém místě najdi maskota Hvězdičku Třpytku a načti QR kód",
    requirement: "Naskenuj QR kód na jakékoli akci a získej šanci vyhrát ceny",
    prizes: ["Poukazy", "Dárkové balíčky"]
  },

  // Children's section
  childrenSection: {
    title: "Pro děti",
    subtitle: "Pro naše nejmenší jsme si připravili omalovánky a pohádku",
    description: "Zatímco objevujete adventní kalendář, mohou si děti užít naše speciální aktivity. Omalovánky s maskotkou Hvězdičkou Třpytkou a vánoční pohádku si můžete stáhnout a užít si je doma.",
    downloads: [
      {
        name: "Vánoční omalovánky",
        description: "Krásné omalovánky s maskotkou Hvězdičkou Třpytku",
        image: "https://customer-assets.emergentagent.com/job_prerov-svetlo/artifacts/n85dtnxh_omalovanky.png",
        downloadUrl: "https://customer-assets.emergentagent.com/job_prerov-svetlo/artifacts/n85dtnxh_omalovanky.png"
      },
      {
        name: "Adventní omalovánky",
        description: "Více omalovanek pro dlouhé zimní večery",
        image: "https://customer-assets.emergentagent.com/job_prerov-svetlo/artifacts/6yihxp0g_omalovanky1.png",
        downloadUrl: "https://customer-assets.emergentagent.com/job_prerov-svetlo/artifacts/6yihxp0g_omalovanky1.png"
      },
      {
        name: "Vánoční pohádka",
        description: "Speciální pohádka o projektu Rozsviť Přerov",
        image: "https://via.placeholder.com/120x160/F7E98E/D4AF37?text=Vánoční+pohádka+PDF",
        downloadUrl: "https://customer-assets.emergentagent.com/job_prerov-svetlo/artifacts/fg6a4jvo_pohadka_rozsvit.pdf"
      }
    ]
  }
};